'use client';

import ReactDOM from 'react-dom';

export function PreloadResources() {
  ReactDOM.preload('https://use.typekit.net/qom6zam.css', { as: 'style' });

  [
    'https://fonts.gstatic.com',
    'https://gstatic.com',
    'https://youtube.com',

    // Google Publisher Tag (Ads)
    'https://securepubads.g.doubleclick.net/tag/js/gpt.js',

    // Loaded here: src/components/HotjarAnalytics/HotjarAnalytics.tsx
    // This could be brought closer in  with a preload, but this will help
    'https://static.hotjar.com',
    'https://connection.facebook.com',
    'https://www.googletagmanager.com',
    'https://facebook.com',

    // This may become less necessary when we lazily load search results
    // or remove them from landings entirely
    `https://${process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}-dsn.algolia.net`,
  ].forEach((u) => {
    ReactDOM.preconnect(u, { crossOrigin: '' });
  });

  return null;
}
